<app-admin-sidebar></app-admin-sidebar>
<div class="account-creation content page" role="main" tabindex="-1" aria-label="Account Creation Page" id="account-creation">
    <div class="head">
      <h1 i18n="Account Creation Title|Title of the Account Creation page@@accountCreationTitle">Account
        Creation</h1>
    </div>
    <p i18n="Account Creation Label Description|Information about creation label@@accountCreationDescription"
       class="account-creation-description">
      Set the available options for users when they create an account.
    </p>
    <p
      i18n="Account Creation Label Description for Required Fields|Information about required fields@@accountCreationRequiredFields"
      class="account-creation-description-required">
      Fields with asterisks (*) are required.
    </p>
    <div class="row roles">

      <div class="col-md-6 column-left">
        <h2 i18n="Roles Section Title|A title for the Roles section@@accountCreationRolesSectionHeading"
            class="roles-title">Roles <span class="required-asterisk">*</span>
        </h2>
        <div>
          <label i18n="Account Creation Roles List|List of Roles of Account Creation@@accountCreationRolesAndAoFLabel"
                 class="account-creation-label"
                 id="account-creation-roles-label"
                 for="account-creation-roles-list">Answer Choices</label>
          <button id="sortButton" i18n="Sort Button|Sort Roles Button@@sortRolesAZ" class="sort-btn btn btn-default"
                  type="button"
                  (click)="sortRoles()">
            <span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span> Sort A-Z
          </button>
        </div>
        <textarea id="account-creation-roles-list" required
                  class="roles text-area required-content" [ngClass]="{'required-roles': checkIfEmptyRoles()}" rows="10"
                  cols="10" name="accountCreationRolesTextArea"
                  [(ngModel)]="chosenRoles" (keyup)="checkMaxLength($event.target, 'roles')">
          </textarea>
        <div class="errors-field-additional">
        <span
          i18n="Each entry should be up to 50 characters|Each entry should be up to 50 characters@@accountCreationRolesLength"
          class="error text-danger" id="roles-maxLength-error" *ngIf="maxLengthRolesExceeded">
          Each entry should be up to 50 characters.
        </span>
          <span
            i18n="You must have at least one role available|You must have at least one role available@@accountCreationRolesEmpty"
            class="error text-danger" *ngIf="checkIfEmptyRoles()">
          This is a required field. Please list at least one role.
        </span>
        </div>
        <div>
          <button i18n="Select from available roles|Roles Available@@selectAvailableRoles"
                  class="select-available-btn btn btn-default" id="roles-open-modal-btn"
                  (click)="openRolesModal()" type="button">Select from available roles
          </button>
        </div>
      </div>
      <div class="col-md-6 column-right">
        <p i18n="Account Creation Roles|Roles Details@@accountCreationRolesDetail" class="help-text-normal"
           id="account-creation-roles-detail">
          Customize the Roles list from which users at your institution select when creating a EndNote Fusion account. You can
          edit and add roles directly in the box or using ‘Select from available roles’. You can change the order by
          dragging and dropping the text in the box or sort alphabetically. Each role should be on a separate line.
          Roles will be displayed in the order in which they appear in the box.</p>
        <p i18n="Account Creation AoF|Roles Details@@accountCreationRolesDetailSecondText" class="help-text-normal"
           id="account-creation-roles-description-second">
          <b>If you edit or delete </b>a previously saved role, all users who had that role will now have an empty
          field; they can reselect a role in Settings.
        </p>
      </div>
    </div>
    <hr>

    <div class="row area-of-focus">
      <div class="col-md-6 column-left">
        <h2 i18n="AoF Section Title|A title for the AoF section@@accountCreationAoFSectionHeading"
            class="aof-title">Areas of Focus</h2>
        <label class="account-creation-label" id="account-creation-aof-label"
               i18n="Account Creation AoF List|List of AoF of Account Creation@@accountCreationRolesAndAoFLabel"
               for="account-creation-aof-list">Answer Choices</label>
        <button i18n="Sort Button|Sort AoF Button@@sortAoFAZ" class="sort-btn btn btn-default"
                (click)="sortAreaOfFocus()"
                type="button">
          <span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span> Sort A-Z
        </button>
        <textarea id="account-creation-aof-list"
                  class="aof text-area" rows="10"
                  name="accountCreationAofTextArea" [(ngModel)]="chosenAreaOfFocus"
                  (keyup)="checkMaxLength($event.target, 'aof')">
      </textarea>
        <span
          i18n="Each entry should be up to 50 characters|Each entry should be up to 50 characters@@accountCreationAofLength"
          class="error text-danger" id="aof-maxLength-error" *ngIf="maxLengthAofExceeded">
              Each entry should be up to 50 characters.
      </span>
        <button i18n="Select from available areas of focus|AoF Available@@selectAvailableAof"
                class="select-available-btn btn btn-default" id="aof-open-modal-btn"
                type="button" (click)="openAreasModal()">Select from available areas of focus
        </button>
      </div>

      <div class="col-md-6 column-right">
        <p i18n="Account Creation AoF|AoF Details@@accountCreationAoFDetailFirstText" class="help-text-normal"
           id="account-creation-aof-description-first">Customize
          the Areas of Focus list from which users at your institution select when creating a EndNote Fusion account. You can
          edit and add areas of focus directly in the box or using ‘Select from available areas of focus’. You can
          change the order by dragging and dropping the text in the box or sort alphabetically. Each area of focus
          should be on a separate line. Areas of focus will be displayed in the order in which they appear in the
          box.</p>
        <p i18n="Account Creation AoF|Roles Details@@accountCreationAoFDetailSecondText" class="help-text-normal"
           id="account-creation-aof-description-second"><b>If
          you edit or delete </b>a previously saved area of focus, all users who had that area of focus will now have an
          empty field; they can reselect an area of focus in Settings.</p>
      </div>
    </div>
    <hr>
    <div class="row button-row">
      <button i18n="Save Button|A label for the button that saves the form@@accountCreationSaveButtonText"
              class="btn btn-primary pull-right save-account-creation" id="saveBtn" (click)="save()">Save
      </button>
    </div>
  </div>





